import { Text, HStack, color } from '@starrez/starryui9';
import React from 'react';
import { IExternalNodeProps } from '../Tree/types';
import { FolderIcon, FolderOpenIcon, Highlighted } from '@starrez/starryui';
import { useProps } from './FolderDropdown';

export const NodeRender: React.FC<IExternalNodeProps> = React.memo(({ caption, visible, isSelected }) => {
    const { search } = useProps();

    return (
        <HStack gap="xSmall">
            <span style={{ color: isSelected ? 'white' : color.Grey.G70 }}>
                {visible ? <FolderOpenIcon Height="16px" Width="16px" /> : <FolderIcon Height="16px" Width="16px" />}
            </span>

            <Text>
                <Highlighted Highlight={search} Text={caption} />
            </Text>
        </HStack>
    );
});
